export const i18nMonitoringPage = {
  statusSummary: {
    status: {
      'open-critical': 'Crítico abierto',
      'open-non-critical': 'No crítico abierto',
      closed: 'Cerrado',
      late: 'Tarde',
      open: 'Abierto',
      alarming: 'Alarmante',
      no_alarms: 'Sin alarmas',
      not_found: 'No encontrado',
    },
  },
  aside: {
    sensors: {
      title: 'Sensores',
      status: {
        ACTIVE: 'Activo',
        DELAYED: 'Demorado',
        NO_DATA: 'Sin datos',
        ALL: 'Todos los estados',
      },
      tooltip: {
        reference: 'Etiqueta de sensor',
        hi: 'Bajo',
        hihi: 'Muy bajo',
        low: 'Alto',
        lowlow: 'Muy alto',
        lo: 'Alto',
        lolo: 'Muy alto',
        subproperties: 'Subpropiedades',

        maximum: 'Max',
        minimum: 'Min',
        'pre-alarm hi': 'Pre-alarme Hi',
        'pre-alarm lo': 'Pre-alarme Lo',
        tag: 'Tag',
        target: 'Target',
      },
      validation_errors: {
        Float: 'Solo se permiten números.',
        Integer: 'Solo se permiten números enteros.',
        Text: 'Solo se permite texto.',
      },
    },
    features: {
      title: 'Características',
    },
    chart: 'Gráfico',
    link: 'Link',
    noData: 'No se encontraron datos para esta sección',
    equipmentData: { title: 'Datos del equipo' },
    operational: { title: 'Operacional' },
    documents: { title: 'Documentos' },
  },
  tables: {
    filters: {
      search: 'Buscar',
      preventive: { 'non-preventive': 'No preventivos', preventive: 'Preventivo', all: 'Todos' },
      dateOptions: {
        180: 'Últimos 180 días',
        365: 'Últimos 365 días',
        730: 'Últimos 730 días',
        1825: 'Últimos 1825 días',
      },
    },

    tabsLabels: {
      SAP_NOTES: 'Notas de mantenimiento',
      MAINTENANCE_PLAN: 'Planes de mantenimiento',
      OIL_ANALYSIS: 'Análisis de aceite',
      VIBRATION_ANALYSIS: 'Análisis de vibración',
      CONDITION_DEVIATION: 'Desviaciónes de condición',
      SIMILAR_ALARMS: 'Alarmas de activos',
      Empty: '',
      CASES: 'Casos',
      UPLOAD: 'Upload',
    },
    columns: {
      SAP_NOTES: {
        description: 'Descripción',
        code: 'Código',
        start_date: 'Inicio',
        end_date: 'Fin',
        type: 'Tipo',
        priority: 'Prioridad',
        link: 'Enlace',
        status: '',
      },
      MAINTENANCE_PLAN: {
        description: 'Descripción',
        code: 'Código',
        group: 'Grupo',
        groupFrequency: 'Frec. de grupo',
        endDate: 'Fecha de vencimiento',
        notes: 'Notas',
        mainItem: 'Artículo principal',
        priority: 'Prioridad',
        status: '',
      },
      OIL_ANALYSIS: { description: 'Análisis' },
      VIBRATION_ANALYSIS: { tag: 'Tag' },
      ALARM_HISTORY: {
        severity: 'Sever.',
        description: 'Descripción',
        start_date: 'Comienzo',
        end_date: 'Termino',
        tags: 'Etiquetas',
        status: 'Estado',
        classification: 'Clasificación',
        noData: 'Sin Clasificación',
      },
    },
    vibrationAnalysisStatus: {
      Normal: 'Normal',
      Observation: 'Observación',
      Critical: 'Crítico',
      Alert: 'Observación',
      noData: '-',
    },

    messages: {
      no_data: {
        SAP_NOTES: 'No hay notas de mantenimiento para mostrar',
        MAINTENANCE_PLAN: 'No hay planes de mantenimiento para mostrar',
        OIL_ANALYSIS: 'No hay análisis de aceite para mostrar',
        VIBRATION_ANALYSIS: 'No hay análisis de vibración para mostrar',
        CONDITION_DEVIATION: 'No hay desviaciones de condición para mostrar',
        SIMILAR_ALARMS: 'No hay alarmas para mostrar',
        Empty: 'No hay datos para mostrar',
      },
      saving: 'Guardando',
      addEvidence: 'Agregar Evidencias',
      selectAtLeastOne: 'Es necesario seleccionar la evidencia en la tabla',
    },
  },
  models: {
    tabs: { models: 'Modelos', scaling_models: 'Modelos de Processo' },
    title: 'Modelos',
    links: { fmea: 'FMEA', PI: 'Pi Vision' },
    noData: 'No hay modelos registrados para este activo',
  },
  summary: {
    title: 'Resumen',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    status: 'Estado',
    days: 'Días',
    currentStatus: 'En el estado actual',
    ableToOperate: 'Capaz de operar',
    unableToOperate: 'Incapaz de operar',
    new: 'Nuevo',
    on: 'Conectado',
    off: 'Apagado',
    stopped: 'Detenido',
    running: 'En funcionamiento',
    unknown: 'Desconocido',
    health: 'Salud',
    alarms: {
      title: 'Alarmas',
      status: {
        OPEN: 'Abierto',
        CLOSED: 'Cerrado',
      },
    },
    deviation: {
      title: 'Cond. Dev.',
      status: {
        COMPLETED: 'Completo',
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Acción emitida',
      },
    },
    sensors: {
      title: 'Sensores',
      status: {
        ACTIVE: 'Activo',
        DELAYED: 'Retraso',
        NO_DATA: 'Sin datos',
      },
    },
  },
  charts: {
    tabsNames: {
      sensors: 'Sensores',
      charts: 'Gráficos',
      features: 'Variables de datos',
      radarView: 'Radar y Plot view',
    },
    noVariables: 'Seleccione una o más variables o sensores arriba para mostrar el gráfico',
    updated: 'Actualizado cada 3 segundos',
    filters: {
      dateOptions: {
        1: 'Última 1 hora',
        6: 'Últimas 6 horas',
        24: 'Últimas 24 horas',
        7: 'Últimos 7 días',
        30: 'Últimos 30 días',
        60: 'Últimos 60 días',
        90: 'Últimos 90 días',
        180: 'Últimos 180 días',
        365: 'Últimos 365 días',
      },
    },
    labels: {
      switch: 'Excluir brechas de datos',
    },
  },
};
